export interface AppData {
    id: string;
    key: string; // Translation key prefix: studigo, imgconvert, etc.
    name: string; // Fallback
    description: string; // Fallback
    icon: string;
    appStoreUrl: string;
    category: string; // Fallback
    features?: string[]; // Fallback
}

export const apps: AppData[] = [
    {
        id: "6477568559",
        key: "studigo",
        name: "Studigo AI: Homework Helper",
        description: "Your personal AI tutor. Scan any homework problem and get instant, step-by-step explanations.",
        icon: "/assets/clean_test_ai_Icon.png",
        appStoreUrl: "https://apps.apple.com/app/id6751319703",
        category: "Education",
    },
    {
        id: "6738624802",
        key: "idphoto",
        name: "証明写真 - ID Photo",
        description: "Create professional ID photos for resume, passport, and license easily. Supports background removal and multiple sizes.",
        icon: "/assets/idphoto_icon.png",
        appStoreUrl: "https://apps.apple.com/app/id6738624802",
        category: "Utility",
    },
    {
        id: "6748907027",
        key: "imgconvert",
        name: "Image & Photo Converter",
        description: "The ultimate tool for converting images between formats. Supports JPEG, PNG, HEIC, and more with no quality loss.",
        icon: "/assets/converter_icon.png",
        appStoreUrl: "https://apps.apple.com/app/id6748907027",
        category: "Productivity",
    },
    {
        id: "6739070413",
        key: "qrreader",
        name: "QR Code Reader",
        description: "Fast and easy-to-use QR code reader and barcode scanner. Supports history and flash.",
        icon: "/assets/codereader_icon.png",
        appStoreUrl: "https://apps.apple.com/app/id6739070413",
        category: "Utility",
    },
];
